import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import Panel from "../components/atoms/Panel";
import { API_URL } from "../Const";
import { Helmet } from "react-helmet";
const mata = require("../assets/mata_laxmi.jpg");

const PanelChart = (props) => {
  const [panelData, setPanelData] = useState();

  const { gameId } = useParams();

  const getData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}api/getPanelData/${gameId}`
      );
      setPanelData(response.data?.data);
    } catch (error) { }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Milan Panel Chart | Satta Matka Casino</title>
        <meta name="description" content="View the Milan Panel Chart and other Satta Matka casino results including Kalyan, Madhur, Star Bazaar, and Star Bazar." />
        <meta name="keywords" content="Satta, matka casino, milan, panel chart, kalyan, madhur, star bazaar, star bazar" />
        <meta property="og:title" content="Milan Panel Chart | Satta Matka Casino" />
        <meta property="og:description" content="Milan Panel Chart and Satta Matka results for Kalyan, Madhur, Star Bazaar, Star Bazar." />
        <meta property="og:image" content={mata} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div>
        <h1 className="text-5xl w-full mb-20 text-blue-600">
          <Link to="/">
            <span className="text-[#F60A00]">SS</span>bossbazar
            <span className="text-[#F60A00]">7.</span>com
          </Link>
        </h1>
        <div className="m-auto lg:max-w-[80%] w-full border-2 border-black">
          <h2 className="bg-sky-400 text-3xl font-bold py-2 text-gray-200 italic">
            {panelData?.gameName?.game_name || ""} PANEL CHART
          </h2>
          <Panel list={panelData?.data} weekData={{ game_weeks: panelData?.gameName?.game_weeks || null }} type="panel" />
        </div>
      </div>
    </>
  );
};

export default PanelChart;
